import React, { useState } from 'react';
import Wrapper from '../../../components/Wrapper';
import Typograpy from '../../../components/Typograpy';
import { useEffect } from 'react';
import groupService from '../../../services/groups';
import Spinner from '../../../components/Spinner';
import RangePicker from '../../../components/RangePicker';
import { Row, Col } from 'antd';
import Select from '../../../components/FormElements/Select';
import BySubcategories from './BySubcategories';
import ByCategories from './ByCategories';
import ByUsersPlan from './ByUsersPlan';
import Reports from './Reports';
import Filters from 'components/Filters';
import { buttons } from './helper';
import ByOrganizations from './ByOrganizations';

export default () => {
  const [active, setActive] = useState('');
  const [groups, setgroups] = useState([]);
  const [activeTab, setActiveTab] = useState('all');

  useEffect(() => {
    groupService
      .getAll()
      .then((res) => {
        setActive(res[0] && res[0]._id);
        setgroups(res);
      })

      .catch((err) => {
        console.log(err);
      });
  }, []);

  const pageHeader = (act) => {
    if (act == '' || !act) {
      return ' гуруҳ  ';
    } else {
      let group = groups.find((val) => val._id === act);
      return group.title;
    }
  };
  const components = {
    all: <Reports active={active} />,
    subCategory: <BySubcategories active={active} />,
    category: <ByCategories active={active} />,
    users: <ByUsersPlan active={active} />,
    organization: <ByOrganizations active={active} />,
  };

  const handleActive = ({ value }) => {
    setActiveTab(value);
  };
  return (
    <Wrapper>
      <Row justify='end' align='middle' gutter={10}>
        <Col span={6}>
          <Select
            handleChange={(value) => {
              setActive(value);
            }}
            name='group'
            options={groups}
            defaultVal={active}
          />
        </Col>
        {activeTab !== 'users' ? (
          <Col>
            <RangePicker />
          </Col>
        ) : null}
      </Row>
      <Typograpy>
        Вилоятдаги барча {pageHeader(active)} томонидан хисобот кесимида
        <br />
        режалаштирилган ва бажарилган ишлар таҳлили бўйича ишлар таҳлили
      </Typograpy>
      <Filters list={buttons} active={activeTab} handleActive={handleActive} />
      {components[activeTab]}
      {/* <Table data={rows} headers={headers} withExcel={true} /> */}
    </Wrapper>
  );
};
